import { motion } from 'framer-motion';
import { 
  ShieldCheckIcon,
  SparklesIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';

const WhyModulo = () => {
  const reasons = [
    {
      title: "AI Integration",
      description: "AI is redefining interaction—are your systems ready for the Internet of AI?",
      icon: SparklesIcon,
      code: "AI_001"
    },
    {
      title: "Privacy First",
      description: "Agentic AI demands smarter data security—let's build with privacy at the core.",
      icon: ShieldCheckIcon,
      code: "PRI_002"
    },
    {
      title: "Future Ready",
      description: "Future-proof your tech: bridge Web2 with Web3 for trusted value exchange.",
      icon: ArrowPathIcon,
      code: "FUT_003"
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.02)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.02)_1px,transparent_1px)] bg-[size:14px_24px]" />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative"
      >
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
          [SYSTEM::WHY_MODULO]
        </div>

        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-6 font-mono">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-400 to-indigo-500">
              Why Modulo Labs
            </span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto font-mono">
            Building the bridge between traditional systems and the future of technology
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/30 to-purple-900/30 rounded-lg backdrop-blur-sm border border-indigo-500/20 
                group-hover:border-indigo-500/40 transition-all duration-300" />
              
              <div className="relative p-8">
                <div className="flex items-center justify-between mb-6">
                  <reason.icon className="w-8 h-8 text-indigo-400" />
                  <div className="font-mono text-xs text-indigo-500/60">{reason.code}</div>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3 font-mono">{reason.title}</h3>
                <p className="text-slate-400 font-mono">{reason.description}</p>

                {/* Corner decorations */}
                <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-indigo-500/20 rounded-tr-lg" />
                <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-indigo-500/20 rounded-bl-lg" />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Footer decoration */}
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
          [END::WHY_MODULO]
        </div>
      </motion.div>
    </section>
  );
};

export default WhyModulo;